"use strict";

exports.__esModule = true;
exports.Connection = void 0;
const Connection = exports.Connection = {
  make: ({
    compId = '',
    ...descriptor
  } = {}) => ({
    compId,
    ...Connection.makeDescriptor(descriptor)
  }),
  makeDescriptor: ({
    properties = {},
    dynamicProperties = {},
    extraData = {},
    behaviors = {}
  } = {}) => ({
    properties,
    dynamicProperties,
    extraData,
    behaviors
  })
};
//# sourceMappingURL=connection.js.map